import { z } from "zod";
export const HORSE_BREEDS = [
    "THOROUGHBRED",
    "PUREBRED_ARABIAN",
    "OTHER",
];
export const HorseBreedSchema = z.enum(HORSE_BREEDS);
export const HORSE_SEXES = [
    "COLT",
    "FILLY",
    "GELDING",
    "MARE",
    "STALLION",
];
export const HorseSexSchema = z.enum(HORSE_SEXES);
/**
 * Closed color dropdown. Genuinely closed/stable per ARCHITECTURE.md §11.7
 * ("PostgreSQL enums only for genuinely closed, stable sets").
 */
export const HORSE_COLORS = [
    "BAY",
    "BLACK",
    "BROWN",
    "CHESTNUT",
    "GREY",
    "PALOMINO",
    "ROAN",
    "WHITE",
    "OTHER",
];
export const HorseColorSchema = z.enum(HORSE_COLORS);
export const RacingCountryCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{3}$/, "Bred In must be a 3-letter racing country code.");
